// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3aZVt","alert":"SettungsInbox_alert__2Tohc"};